import React from "react";
import "./App.css";
import "material-react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "material-react-toastify";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Hero from "./sections/Hero";
import Achievements from "./sections/Achievements";
import About from "./sections/About";
import Skills from "./sections/Skills";
import Experience from "./sections/Experience";
import FeaturedProject from "./sections/FeaturedProject";
import KeyAchievements from "./sections/KeyAchievements";
import Projects from "./sections/Projects";
import Certifications from "./sections/Certifications";
import Blog from "./sections/Blog";
import Contact from "./sections/Contact";

function App() {
  return (
    <div className="relative min-h-screen overflow-x-hidden bg-slate-50 text-slate-900">
      <div className="pointer-events-none absolute -left-32 top-0 h-[28rem] w-[28rem] rounded-full bg-indigo-300/30 blur-3xl" />
      <div className="pointer-events-none absolute right-[-10rem] top-[16rem] h-[24rem] w-[24rem] rounded-full bg-sky-300/25 blur-3xl" />
      <div className="pointer-events-none absolute left-[22%] top-[48rem] h-[22rem] w-[22rem] rounded-full bg-emerald-300/20 blur-3xl" />
      <div className="pointer-events-none absolute right-[12%] top-[72rem] h-[18rem] w-[18rem] rounded-full bg-blue-300/20 blur-3xl" />
      <Navbar />
      <main className="relative z-10">
        <Hero />
        <Achievements />
        <About />
        <Skills />
        <Experience />
        <FeaturedProject />
        <KeyAchievements />
        <Projects />
        <Certifications />
        <Blog />
        <Contact />
      </main>
      <Footer />
      <ToastContainer
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop={true}
        pauseOnHover={true}
        theme="light"
      />
    </div>
  );
}

export default App;
